import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// used to create fake backend
//import { fakeBackendProvider } from './_helpers';
import * as $ from 'jquery';
import { from } from 'rxjs';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { ModalModule } from './_modal';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ForgotPasswordComponent } from '@app/authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '@app/authentication/reset-password/reset-password.component';
import { NewsComponent } from './news/news.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { WebcamModule } from 'ngx-webcam';
import { CameraComponent } from './camera/camera.component';
import { TermsComponent } from './terms/terms.component';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { FormsModule } from '@angular/forms';

//import { SharedModule} from '@app/shared/shared.module'
@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        ModalModule,
        NgImageSliderModule,
        WebcamModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }, isolate: false
        })
  //      SharedModule
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        SignUpComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        NewsComponent,
        NotificationsComponent,
        CameraComponent,
        TermsComponent,

    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

        // provider used to create fake backend
        //fakeBackendProvider
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}